import { useEffect } from "react";
import { useGame } from "../../../context/GameContext";
import "./statusScreen.scss";
import { QRCodeCanvas } from "../../multiplayer/QRCodeCanvas";
import ChessButton from "../../visual/ChessButton/ChessButton";
import { eventEndGame } from "../../../utils/gtag";
import { MultiplayerState, useMultiplayer } from "../../../context/MultiplayerContext";
/**
 * The status screen component for displaying game status to the player
 * such as loading screens, errors, etc.
 */
export default function StatusScreen() {
    const { status, setStatus } = useGame();
    const { multiplayerState, setMultiplayerState } = useMultiplayer();

    // Immediately focus the first button when the loading screen is rendered.
    useEffect(() => {
        document.body.style.backgroundImage = "url('images/table2-4k.webp')";
        const startButton = document.querySelectorAll("button")[0];
        startButton?.focus();
    });

    if (!status.showStatusPage) return null;

    /**
     * Closes the status page
     */
    function onClick() {
        setStatus({ showStatusPage: false });
        setMultiplayerState((prevState: MultiplayerState) => ({ ...prevState, joinGame: false }));
    }

    return (
        <div className="status-screen" data-testid="status-screen">
            <div id="elements">
                <h2>{status.message}</h2>
                {status.showLoadingIndicator && <div className="dot-spin"></div>}
                <ChessButton
                    onClick={() => {
                        onClick();
                        eventEndGame(2);
                    }}
                >
                    Home
                </ChessButton>
            </div>
            <div className="qr-container">
                <QRCodeCanvas lobbyId={multiplayerState.lobbyId} id="qr-code-loading" />
            </div>
        </div>
    );
}
